export enum PaymentTime {
  PayNow,
  PayLater,
}
